<fhm-page [title]="title" [showSave]="newCustomerInstanceGroup"
  [showDone]="true"
  (doneClicked)="done()"
  (saveClicked)="save()"
  [description]="'fhm.customer-instance-group.description' | translate">

  <fui-rows [formGroup]="formGroup">
    <fui-row [label]="'Group'">
      <fui-column>
        <fui-rows>
          <fui-row>
            <fui-two-columns>
              <fui-column>
                <fui-text-control formControlName="groupId"
                  [disabled]="!newCustomerInstanceGroup"
                  [control]="formGroup.get('groupId')"
                  [label]="'fhm.customer-instance-group.groupId.label'"
                  [placeholder]="'fhm.customer-instance-group.groupId.placeholder'"
                [(ngModel)]="data.groupId"></fui-text-control>
              </fui-column>
              @if (newCustomerInstanceGroup) {
                <fui-column>
                  <fui-inline-information [title]="'fhm.customer-instance-group.messages.groupId.title'"
                  [message]="'fhm.customer-instance-group.messages.groupId.message'"></fui-inline-information>
                </fui-column>
              }

              <fui-column>
                @if (subscriptionData && !newCustomerInstanceGroup) {
                  <fui-tandem-field>
                    <fui-text-control [value]="subscriptionData.currentBillingPeriodStartFormatted"
                      [label]="'fhm.venue-plan.currentBillingPeriodStart'"
                      [disabled]="true">
                    </fui-text-control>
                    <fui-text-control [value]="subscriptionData.currentBillingPeriodEndFormatted"
                      [label]="'fhm.venue-plan.currentBillingPeriodEnd'"
                      [disabled]="true">
                    </fui-text-control>
                  </fui-tandem-field>
                }
              </fui-column>


            </fui-two-columns>
          </fui-row>
          <fui-row>
            <fui-two-columns>
              <fui-column>
              </fui-column>
              @if (groupSales && !newCustomerInstanceGroup) {
                <fui-column>
                  <fui-numeric-control [label]="'Sales Last Period'"
                    [placeholder]="' '"
                    [disabled]="true"
                    [decimals]="0"
                    [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="groupSales.salesTotalLastPeriod"></fui-numeric-control>
                </fui-column>
              }
            </fui-two-columns>
          </fui-row>

        </fui-rows>
      </fui-column>

    </fui-row>

    @if (!newCustomerInstanceGroup) {
      <fui-row [label]="'Instances'">
        <fui-column>
          <div class="venues-action">
            <fhm-provision-button [title]="'Add Existing Instance'" (clicked)="addExistingInstance()"></fhm-provision-button>
          </div>
          <fhm-search-grid [records]="instances" [columns]="['clientId', 'deploymentStatus']" [type]="'customer-instance-group.instances'"
            [showLink]="true" (selectRecord)="editInstance($event)">
          </fhm-search-grid>
        </fui-column>
      </fui-row>
    }
  </fui-rows>
</fhm-page>
